import TimeoutError from './TimeoutError'
import wait from './wait'

const poll = async (doFn, successFn = () => true, maxAttempts = 30, delayMs = 1000) => {
  let attempts = 0
  let succeeded = false
  let result = null

  while (!succeeded && attempts++ < maxAttempts) {
    result = await doFn()
    succeeded = successFn(result)
    if (!succeeded) {
      await wait(delayMs)
    }
  }

  if (!succeeded) {
    throw new TimeoutError(`Polling every ${delayMs}ms for ${attempts} attempts was unsuccessful.`)
  }

  return result
}

export default poll
